import React from 'react';
import './AboutUs.css';
import Footer from '../Footer/Footer';
import Navbar1 from '../Navbar/Navbar1/Navbar1';
import bottomImage from '../../assets/Bottom.png';

const AboutUs = ({ onNavigate }) => {
  return (
    <div className="about-page">
      <Navbar1 onNavigate={onNavigate} />
      <div className="aboutus-container">
        <section className="aboutus-hero">
        <img src={bottomImage} alt="Oil Rig" className="aboutus-hero-image" />
        <div className="aboutus-hero-text">
          <h1>About Us</h1>
          <p>AI Shipshape Ltd<br />Engineering Trust. Navigating the Future.</p>
        </div>
      </section>

      
        <section className="who-we-are-section">
         <div className="who-we-are-content">
          <h2>Who We Are ?</h2>
          <p>
            AI Shipshape Ltd is a UK-based maritime AI company at the heart of the global shipping industry.
            Strategically headquartered in London, one of the world's most influential maritime and technology hubs,
            we are driving a new era of intelligent shipping—where engineering precision meets artificial intelligence.
          </p>
          <p>
            We are a team of veteran maritime professionals, engineers, naval architects, data scientists, and AI technologists
            with a shared purpose: to transform the maritime landscape through focused, compliant, and profit-driven innovation.
          </p>
          <p>
            Our platform combines deep operational understanding with advanced AI to deliver real-world solutions that enhance
            efficiency, compliance, profitability, and sustainability across the shipping value chain—from ship to shore.
          </p>
        </div>


      </section>



    <section className="mission-section">
      <h2>Our Mission</h2>
      <div className="mission-card">
        <p>
          To enable the maritime world to operate with clarity, confidence, and control by delivering
          cutting-edge AI solutions that are deeply rooted in maritime best practices and core engineering principles.
        </p>
        <p>
          We exist to empower shipowners, managers, crew, and shore teams with the tools they need to
          reduce cost, enhance compliance, improve uptime, and plan smarter—without overhauling existing systems.
        </p>
      </div>
    </section>

    <section className="our-vision-section">
    <h2>Our Vision</h2>
    <div className="vision-card">
      <p>
        To become the global standard in maritime AI by shaping a future where every vessel and every voyage
        benefits from intelligent decision support.
      </p>
      <p>
        A future where shipping operations are safer, cleaner, and more profitable—driven by actionable insight,
        not just raw data.
      </p>
    </div>
  </section>
      <section className="our-value-section">
      <h2>Our Value</h2>
      <div className="value-grid">
        <div className="value-card">
          <h3>Engineering First</h3>
          <p>We build with deep respect for maritime engineering. Our solutions are grounded in real-world ship operations, not just theoretical models.</p>
        </div>
        <div className="value-card">
          <h3>Maritime at the Core</h3>
          <p>Everything we do is maritime-specific—from our algorithms to our interfaces. We're not adapting generic AI—we're building AI for shipping.</p>
        </div>
        <div className="value-card">
          <h3>Practical Innovation</h3>
          <p>We focus on solving real problems, not chasing trends. Every feature we create has a measurable impact—on cost, compliance, uptime, or sustainability.</p>
        </div>
        <div className="value-card">
          <h3>Trust & Integrity</h3>
          <p>We believe in reliability, transparency, and safety. Our systems are designed to be accountable, auditable, and evidence-based—because in shipping, trust matters.</p>
        </div>
        <div className="value-card">
          <h3>Built for the Front Line</h3>
          <p>From bridge officers to superintendents, our tools are designed to help those who make real decisions—quickly, clearly, and confidently.</p>
        </div>
        <div className="value-card">
          <h3>Data That Works</h3>
          <p>We don't just collect data. We convert it into decisions, actions, and outcomes that matter. Fuel savings. Fewer fines. Optimised voyages. Smarter fleets.</p>
        </div>
      </div>
    </section>



    <section className="why-uk-section">
    <div className="why-uk-container">
      <h2>Why the UK?</h2>
      <p>
        <strong>The UK is not just our home—it’s our foundation.</strong> With London as a global maritime capital, we are perfectly
        positioned to stay ahead of regulatory change, access world-class technical talent, and remain closely aligned with the
        industry's evolving needs.
      </p>
      <p>
        Our proximity to global classification societies, regulatory bodies, insurers, P&amp;I clubs, and shipowners gives us a unique
        advantage in designing AI solutions that are not only technically sound—but also commercially and legally relevant.
      </p>
    </div>
  </section>

  <section className="different-section">
  <h2>What Makes Us Different?</h2>

  <div className="different-grid">
    <div className="different-card">
      
        Multiple patents pending with <br />
        several more in the pipeline
      
    </div>

    <div className="different-card">
      Modular, plug-and-play AI systems built<br />
      to work on top of your existing setup—no<br />
      disruptions required
    </div>

    <div className="different-card">
      Designed by maritime professionals, for<br />
      maritime professionals
    </div>

    <div className="different-card">
      Trusted by forward-looking companies<br />
      across the UK, Europe, and Asia
    </div>
  </div>
</section>


      <Footer onNavigate={onNavigate} />
    </div>
    </div>
  );
};

export default AboutUs;
